//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RankingListItem from "./RankingListItem.vue";
import RankingListFilter from "./RankingListFilter.vue";

export default {
	name: "ranking-list",
	components: {
		RankingListItem,
		RankingListFilter,
	},
	props: {
		list: {
			type: Array,
			required: true,
		},
		title: {
			type: Function,
			required: true,
		},
		tags: {
			type: Function,
			required: false,
		},
		checkShow: {
			type: Boolean,
			required: false,
			default: true,
		},
		desc: {
			type: Function,
			required: true,
		},
		imgUrl: {
			type: Function,
			required: false,
			default: function (entry) {
				return entry.image;
			},
		},
		to: {
			type: Function,
			required: false,
			default: (e) => ``,
		},
		showFilter: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
};
